import { render } from "./DoctorSelect.vue?vue&type=template&id=26b4a767&scoped=true"
import script from "./DoctorSelect.vue?vue&type=script&lang=js"
export * from "./DoctorSelect.vue?vue&type=script&lang=js"

import "./DoctorSelect.vue?vue&type=style&index=0&id=26b4a767&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26b4a767"]])

export default __exports__